import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MissingFieldService } from './missing-field.service';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-modal-missing-fields',
  templateUrl: './modal-missing-fields.component.html',
  styleUrls: ['./modal-missing-fields.component.css'],
})
export class ModalMissingFieldsComponent implements OnInit {
  form = new FormGroup({});
  model: object = {};
  showLoader = false;
  constructor(
    public dialogRef: MatDialogRef<ModalMissingFieldsComponent>,
    @Inject(MAT_DIALOG_DATA) public fields: FormlyFieldConfig[],
    private missingFieldService: MissingFieldService
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    if (this.form.valid) {
      this.showLoader = true;
      this.missingFieldService.sendFixedFields(this.model).subscribe(
        () => {
          this.showLoader = false;
          this.dialogRef.close();
        },
        (error) => {
          this.showLoader = false;
        }
      );
    }
  }
}
